<template>
  <div
    ref="container"
    class="media-hotspot relative text-white overflow-hidden bg-black flex-1 h-full flex"
  >
    <p
      v-if="hotspot.content"
      class="image-description absolute top-full left-0 w-full h-full max-h-full p-4 m-0 bg-black bg-opacity-60 transition-all whitespace-pre-line z-30"
      :class="isDescriptionOpenLocally ? '-translate-y-full overflow-auto' : '-translate-y-32'"
      @click="toggleImageDescription"
    >
      <ChevronUpIcon class="icon w-6 m-auto transition-transform block mb-4 cursor-pointer pointer-events-auto" :class="{'rotate-180': isDescriptionOpenLocally}" />
      {{ hotspot.content }}
    </p>
    <img v-if="type === 'I'" ref="image" class="hotspot-image z-10" :src="hotspot.media[0].url || undefined" />
    <iframe
      v-if="type === 'V'"
      class="hotspot-image aspect-video max-w-full w-full max-h-full w-xl z-10"
      :src="hotspot.media[0].url || undefined"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    />
  </div>
</template>

<script lang="ts" setup>
import { ChevronUpIcon } from '@heroicons/vue/20/solid'
import type { Hotspot, HotspotType } from '@/entities/site'

const props = defineProps({
  hotspot: {
    type: Object as PropType<Hotspot>,
    required: true,
  },
  type: {
    type: String as PropType<HotspotType>,
    required: true,
  },
  contentStyle: {
    type: Object as PropType<Partial<CSSStyleDeclaration>>,
    default: () => ({}),
  },
  isDescriptionOpen: {
    type: Boolean,
    default: false,
  },
  allowExpansion: {
    type: Boolean,
    default: () => true,
  },
})

const emit = defineEmits(['update:image-dimensions', 'toggle-image-description'])

const { isDescriptionOpen } = toRefs(props)
const image = ref<HTMLImageElement | undefined>()
const isDescriptionOpenLocally = ref(false)

watch(
  isDescriptionOpen,
  isDescriptionOpen => {
    isDescriptionOpenLocally.value = isDescriptionOpen
  },
  { immediate: true }
)

function toggleImageDescription() {
  if (!props.allowExpansion) return
  isDescriptionOpenLocally.value = !isDescriptionOpenLocally.value
  emit('toggle-image-description')
}
</script>

<style>
.hotspot-image {
  max-height: calc(var(--deckWindowHeight) - 10.5rem)
}
</style>
